module.exports = __webpack_public_path__ + "static/img/2.ac1b9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 2